// Third Party Imports
import React from 'react';
import FormSelect from '@homeaway/react-form-select';
import {FormInput} from '@homeaway/react-form-components';

const BusinessTypeInput = (props) => {
    let {
        translations,
        businessType
    } = props;

    return (
        <FormSelect
            id="businessType"
            type="text"
            items={[{value: businessType, label: translations['ipmob.company_location.business_type.other']}]}
            name="Business type selected"
            label={translations['ipmob.company_location.label']}
            value={businessType}
            maxLength="64"
        />);
};

const PropertyCountInput = (props) => {
    let {
        translations,
        propertyCountVal
    } = props;

    return (
        <FormInput
            id="numberOfProperties"
            type="number"
            name="numberOfProperties"
            label={translations['ipmob.property_count.label']}
            value={propertyCountVal}
            maxLength="64"
        />);
};

const VatChoiceInput = (props) => {
    let {
        translations,
        vatNumberChoice
    } = props;

    return (
        <FormSelect
            id="vatNumber"
            type="text"
            items={[{value: vatNumberChoice, label: vatNumberChoice}]}
            name="vatNumber"
            label={translations['ipmob.vat_page.label_2']}
            value={vatNumberChoice}
            maxLength="64"
        />);
};

export {
    BusinessTypeInput,
    PropertyCountInput,
    VatChoiceInput
};
